import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import "./fieldForce.css";
import back from "../../assets/back.svg";
import Select from "react-select";
import InputField from "../../components/form/inputField/inputField";
import { NavLink, useNavigate } from "react-router-dom";
import { AdminButton } from "../../components/buttons/versionHistoryBtn";
import { useDispatch } from "react-redux";
import {
  designationList,
  fieldForceUserCreate,
  headQuaterList,
  reportingManagerList,
} from "../../redux/actions/fieldForceAction";
import useBreadcrumbs from "use-react-router-breadcrumbs";
import ErrorMsg from "../../components/form/errorMsg";
import { vendorDivisionList } from "../../redux/actions/productActions";
import CreatedPopUp from "../../components/popups/CreatedPopUp";
import InputCapitalField from "../../components/form/inputField/inputCapitalField";
import ErrorPopup from "../../components/popups/ErrorPopup";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

const FieldForceCreate = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [designationOptions, setDesignationOptions] = useState([]);
  const [headQuaterOptions, setHeadQuaterOptions] = useState([]);
  const [reportingManagerOptions, setReportingManagerOptions] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [created, setCreated] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");

  useEffect(() => {
    dispatch(designationList(DesignationListSuccess, DesignationListError));
    dispatch(vendorDivisionList(onDevisionSuccess, onDevisionError));
    dispatch(headQuaterList(fetchHeadQuaterSuccess, fetchHeadQuaterError));
  }, []);

  useEffect(() => {
    if (selectedDivision.length > 0 && selectedLevel !== null) {
      dispatch(
        reportingManagerList(
          { division_id: selectedDivision, approval_level: selectedLevel },
          fetchReportingManagerListSuccess,
          fetchReportingManagerListError
        )
      );
    }
  }, [selectedDivision, selectedLevel]);

  const DesignationListSuccess = (data) => {
    console.log(data);
    setDesignationOptions(data);
  };

  const DesignationListError = (err) => {
    console.log(err);
  };

  const onDevisionSuccess = (data) => {
    setDivisionList(data);
    console.log(data);
  };

  const onDevisionError = (err) => {
    console.log(err);
  };

  const fetchHeadQuaterSuccess = (data) => {
    setHeadQuaterOptions(data);
  };

  const fetchHeadQuaterError = (data) => {
    console.log(data);
  };

  const fetchReportingManagerListSuccess = (data) => {
    setReportingManagerOptions(data);
  };

  const fetchReportingManagerListError = (data) => {
    console.log(data);
  };

  const phoneRegex = /^([+]\d{2})?\d{10}$/;
  const alphaNumRegex = /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/;

  const initialValues = {
    employee_id: "",
    employee_name: "",
    email: "",
    country_code: "91",
    mobile: "",
    designation_id: "",
    // division_id: "",
    head_quaters: [],
    reporting_manager: "",
    divisions: [],
  };
  const clearFunc = (setFieldValue) => {
    setFieldValue("employee_id", "");
    setFieldValue("employee_name", "");
    setFieldValue("email", "");
    setFieldValue("mobile", "");
    setFieldValue("designation_id", "");
    // setFieldValue("division_id", "");
    setFieldValue("divisions", []);
    setFieldValue("head_quaters", []);
    setFieldValue("reporting_manager", "");
  };
  const validationSchema = Yup.object().shape({
    employee_id: Yup.string()
      .matches(alphaNumRegex, "Not a proper employee id")
      .required("Required"),
    employee_name: Yup.string().required("Required"),
    email: Yup.string().email("Not a proper email").required("Required"),
    mobile: Yup.string()
      .matches(phoneRegex, "Not a valid Number")
      .required("Required"),
    designation_id: Yup.string().required("Required"),
    head_quaters: Yup.array().when("selectedLevel", {
      is: () => selectedLevel != "admin",
      then: Yup.array()
        .required("Required")
        .min(1, "At least one should be selected"),
      otherwise: Yup.array(),
    }),
    divisions: Yup.array().when("selectedLevel", {
      is: () => selectedLevel != "admin",
      then: Yup.array()
        .required("Required")
        .min(1, "At least one should be selected"),
      otherwise: Yup.array(),
    }),
    reporting_manager: Yup.string().when("selectedLevel", {
      is: () => selectedLevel != "admin",
      then: Yup.string().required("Required"),
      otherwise: Yup.string(),
    }),
  });

  const onSubmit = (values) => {
    console.log(values);
    dispatch(fieldForceUserCreate(values, onSuccess, onError));
  };

  const onSuccess = (data) => {
    console.log(data);

    setCreated(true);
    const timeOutFnc = () => {
      setCreated(false);
      navigate("/field-force/user/:1");
    };

    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    { path: "/field-force/user", breadcrumb: " / field force / users" },
    { path: "/field-force/user/create", breadcrumb: " / create" },
  ];
  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  return (
    <div className="products-page">
      <div className="products-main-div">
        <div className="mx-3">
          {breadcrumbs.map(({ match, breadcrumb }) => (
            <NavLink
              key={match.pathname}
              to={match.pathname}
              className="header-route-page fw_400 cursor_pointer"
            >
              <span className="fs_18">{breadcrumb}</span>
            </NavLink>
          ))}
        </div>
        <div className="products-main-list my-2 py-1">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ setFieldValue, values }) => (
              <Form className="">
                <div className="search-container d-flex justify-content-between align-items-center">
                  <div
                    className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                    onClick={() => navigate(-1)}
                  >
                    <img src={back} alt="back_btn" />
                    <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                      BACK
                    </span>
                  </div>
                  <div className=" d-flex justify-content-between m-1 mb-2">
                    <AdminButton
                      background="#E7E5FF"
                      width="100px"
                      onClick={() => clearFunc(setFieldValue)}
                    >
                      CLEAR
                    </AdminButton>
                    <AdminButton
                      background="#7065e4"
                      color="white"
                      width="100px"
                      type="submit"
                    >
                      <span className="m-2">SAVE</span>
                    </AdminButton>
                  </div>
                </div>

                <div className="form-width ms-4 ps-3 py-1">
                  <div className="my-2">
                    <InputCapitalField
                      setFieldValue={setFieldValue}
                      id={"employee_id"}
                      label={"Company Employee ID"}
                      labelColor={"color_262c3d"}
                      type={"text"}
                      placeholder={"Enter employee id"}
                      name={"employee_id"}
                      value={values?.employee_id}
                    />
                  </div>

                  <div className="my-2">
                    <InputCapitalField
                      setFieldValue={setFieldValue}
                      id={"employee_name"}
                      label={"Employee Name"}
                      labelColor={"color_262c3d"}
                      type={"text"}
                      placeholder={"Enter employee name"}
                      name={"employee_name"}
                      value={values?.employee_name}
                    />
                  </div>
                  <div className="my-2">
                    <InputField
                      setFieldValue={setFieldValue}
                      maxLength="10"
                      id={"mobile"}
                      label={"Phone Number"}
                      labelColor={"color_262c3d"}
                      type={"text"}
                      placeholder={"Enter phone number"}
                      name={"mobile"}
                      value={values?.mobile}
                    />
                  </div>
                  <div className="my-2">
                    <InputField
                      setFieldValue={setFieldValue}
                      id={"email"}
                      label={"Email Address"}
                      labelColor={"color_262c3d"}
                      type={"text"}
                      placeholder={"Enter email address"}
                      name={"email"}
                      value={values?.email}
                    />
                  </div>
                  <div className="my-2">
                    <label className="color_262c3d fw_400 fs_14 my-1">
                      Designation
                    </label>
                    <Field>
                      {({ form, Field }) => (
                        <Select
                          options={designationOptions}
                          styles={customStyles}
                          {...Field}
                          placeholder={"Select Role"}
                          id="designation_id"
                          value={designationOptions.filter(
                            (c) => c.value == values?.designation_id
                          )}
                          onChange={(selectedOption) => {
                            setSelectedLevel(selectedOption?.approval_level);
                            form.setFieldValue(
                              "designation_id",
                              selectedOption.value
                            );
                          }}
                        />
                      )}
                    </Field>
                    <ErrorMsg name="designation_id" />
                  </div>
                  {selectedLevel != "admin" && (
                    <>
                      <div className="my-2">
                        <label className="color_262c3d fw_400 fs_14 my-1">
                          Division Name
                        </label>
                        <Field>
                          {({ form, Field }) => (
                            <Select
                              isMulti
                              options={divisionList}
                              styles={customStyles2}
                              {...Field}
                              placeholder={"Select Divisions"}
                              id="divisions"
                              value={divisionList.filter((o1) =>
                                values?.divisions?.some((o2) => o2 == o1.value)
                              )}
                              onChange={(selectedOption) => {
                                setSelectedDivision(
                                  selectedOption
                                    ? selectedOption.map((item) => item.value)
                                    : []
                                );
                                form.setFieldValue(
                                  "divisions",
                                  selectedOption
                                    ? selectedOption.map((item) => item.value)
                                    : []
                                );
                              }}
                            />
                          )}
                        </Field>
                        <ErrorMsg name="divisions" />
                      </div>
                      <div>
                        <div className="my-2">
                          <label className="color_262c3d fw_400 fs_14 my-1">
                            Head Quaters
                          </label>

                          <Field>
                            {({ form, Field }) => (
                              <Select
                                isMulti
                                options={headQuaterOptions}
                                styles={customStyles2}
                                {...Field}
                                placeholder={"Select Areas"}
                                id="head_quaters"
                                value={headQuaterOptions.filter((o1) =>
                                  values?.head_quaters?.some(
                                    (o2) => o2 == o1.value
                                  )
                                )}
                                onChange={(selectedOption) => {
                                  let newArr = values.head_quaters;
                                  form.setFieldValue(
                                    "head_quaters",
                                    selectedOption
                                      ? selectedOption.map((item) => item.value)
                                      : []
                                  );
                                }}
                              />
                            )}
                          </Field>
                          <ErrorMsg name="head_quaters" />
                        </div>
                      </div>
                      <div className="my-2 mb-5">
                        <label className=" color_262c3d fw_400 fs_14 my-1">
                          Reporting Manager
                        </label>

                        <Field>
                          {({ form, Field }) => (
                            <Select
                              options={reportingManagerOptions}
                              styles={customStyles}
                              {...Field}
                              placeholder={
                                "Select reporting manager / Superior"
                              }
                              id="reporting_manager"
                              name="reporting_manager"
                              value={reportingManagerOptions.filter(
                                (c) => c.value == values?.reporting_manager
                              )}
                              onChange={(selectedOption) => {
                                form.setFieldValue(
                                  "reporting_manager",
                                  selectedOption.value
                                );
                              }}
                            />
                          )}
                        </Field>
                        <ErrorMsg name="reporting_manager" />
                      </div>
                    </>
                  )}
                </div>
              </Form>
            )}
          </Formik>
        </div>
        <CreatedPopUp
          show={created}
          handelClose={() => setCreated(false)}
          title={"Field Force User Created Successfully"}
        />
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </div>
    </div>
  );
};

export default FieldForceCreate;

export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    height: "43px",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};

export const customStyles2 = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
